import * as angular from "angular";
import {ContractPriceType} from "../types/contract-price.type";


const availableContractPriceTypesByMethod = {
  ServiceAreas: [ContractPriceType.ByDistance, ContractPriceType.BySpot, ContractPriceType.ByPackageSize],
  Locations: [ContractPriceType.ByPackageSize],
  Vehicle: [ContractPriceType.ByDistance, ContractPriceType.ByDistanceUnit],
  DeliveryAmount: [ContractPriceType.ByCommission]
};

angular
  .module('bringoz.admin.contracts')
  .constant('contractsConstants', {
    availableContractPriceTypesByMethod: availableContractPriceTypesByMethod,

  });
